var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2V5.6L14 5.6V2L2 2Z",
    fill: "#FFA941"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29999 10.4V14H14.3V10.4H2.29999Z",
    fill: "#019604"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.60001V10.4H14V5.60001L2 5.60001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.125C9.13909 6.125 10.0625 7.04841 10.0625 8.1875C10.0625 9.32659 9.13909 10.25 8 10.25C6.86091 10.25 5.9375 9.32659 5.9375 8.1875C5.9375 7.04841 6.86091 6.125 8 6.125ZM8 6.5C7.06802 6.5 6.3125 7.25552 6.3125 8.1875C6.3125 9.11948 7.06802 9.875 8 9.875C8.93198 9.875 9.6875 9.11948 9.6875 8.1875C9.6875 7.25552 8.93198 6.5 8 6.5Z",
    fill: "#021A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.3125C8.62132 9.3125 9.125 8.80882 9.125 8.1875C9.125 7.56618 8.62132 7.0625 8 7.0625C7.37868 7.0625 6.875 7.56618 6.875 8.1875C6.875 8.80882 7.37868 9.3125 8 9.3125Z",
    fill: "#021A9A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndSm);
export default __webpack_public_path__ + "static/media/IND-SM.5230e99e997863907bd4e510071917ae.svg";
export { ForwardRef as ReactComponent };